import { render, staticRenderFns } from "./PrehledTrzebDilnyDleDokladuAZpusobuPlatby.vue?vue&type=template&id=2cb64da4&"
import script from "./PrehledTrzebDilnyDleDokladuAZpusobuPlatby.vue?vue&type=script&lang=ts&"
export * from "./PrehledTrzebDilnyDleDokladuAZpusobuPlatby.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports